import { render } from "./DeviationDisruptionTable.vue?vue&type=template&id=1da2a314"
import script from "./DeviationDisruptionTable.vue?vue&type=script&lang=ts"
export * from "./DeviationDisruptionTable.vue?vue&type=script&lang=ts"
script.render = render

export default script